/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Step1description1Inputs */

const he_extension_step1description1 = /** @type {(inputs: Extension_Step1description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התקינו את התוסף דרך חנות התוספים של הדפדפן שלכם`)
};

const en_extension_step1description1 = /** @type {(inputs: Extension_Step1description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install the extension from your browser's extension store`)
};

/**
* | output |
* | --- |
* | "Install the extension from your browser's extension store" |
*
* @param {Extension_Step1description1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_step1description1 = /** @type {((inputs?: Extension_Step1description1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Step1description1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_step1description1(inputs)
	return en_extension_step1description1(inputs)
});
export { extension_step1description1 as "extension_step1Description" }